import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal, NumberInput, TextInput, CheckBox } from 'hyperdb-utils';
import api from 'api';

const UnitsFieldset = (props) => {
  if (props.hasOwnProperty('show') && !props.show) return null;
  return (
    <fieldset>
      <legend>
        Units
        &nbsp;
        {
          !props.noCreate
            ? <button type="button" className="btn btn-xs btn-primary" onClick={ handleToggleModalForm.bind(null, props, true, -1) }>Add</button>
            : null
        }
      </legend>
      <div className="table-responsive no-padding">
        <table className="table table-hover table-striped table-bordered table-responsive">
          <thead>
            <tr>
              <th>number</th>
              <th>description</th>
              { props.showRemoteId ? <th>remote_unit_id</th> : null }
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              props.units.map((unit, i) => {
                return (
                  <tr key={ i }>
                    <td>{unit.number || i}</td>
                    <td>{unit.description}</td>
                    { props.showRemoteId ? <td>{ unit.remote_unit_id }</td> : null }
                    <td>
                      <DropdownButton title={ <span><i className="fas fa-caret" /> Actions</span> } pullRight bsSize="small" id="Menu actions">
                        <MenuItem onClick={ handleToggleModalForm.bind(null, props, true, i) }>Edit</MenuItem>
                        {
                          props.units.length > 1
                            ? <MenuItem onClick={ handleToggleModalDelete.bind(null, props, i) }>Delete</MenuItem>
                            : null
                        }
                      </DropdownButton>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
      {
        props.showModalFormUnit
          ? <Modal title={ props.indexEditedUnit === -1 ? 'Add unit' : 'Edit unit' } onClose={ handleToggleModalForm.bind(null, props, false) } onAccept={ handleSaveUnit.bind(null, props) }>
              <fieldset>
                <CheckBox
                  label="Active"
                  name="active"
                  checked={ props.editedUnit.active }
                  onChange={ handleChangeUnit.bind(null, props, 'active') }
                />
                <NumberInput
                  label="Number"
                  name="number"
                  value={ props.editedUnit.number }
                  onChange={ handleChangeUnit.bind(null, props, 'number') }
                  disabled={ true }
                />
                <TextInput
                  label="Description"
                  name="description"
                  value={ props.editedUnit.description }
                  onChange={ handleChangeUnit.bind(null, props, 'description') }
                />
                {
                  props.showIcal
                    ? <TextInput
                        label="ICAL URL"
                        name="remote_ical_url"
                        value={ props.editedUnit.remote_ical_url }
                        onChange={ handleChangeUnit.bind(null, props, 'remote_ical_url') }
                      />
                    : null
                }
                {
                  props.showRemoteId
                    ? <div>
                    <TextInput
                      label="remote_unit_id"
                      name="remote_unit_id"
                      value={ props.editedUnit.remote_unit_id }
                      onChange={ handleChangeUnit.bind(null, props, 'remote_unit_id') }
                    />
                    <TextInput
                      label="remote_property_id"
                      name="remote_property_id"
                      value={ props.editedUnit.remote_property_id }
                      onChange={ handleChangeUnit.bind(null, props, 'remote_property_id') }
                    />
                    </div> : null
                }
              </fieldset>
            </Modal>
          : null
      }
      {
        props.showModalDeleteUnit
          ? <Modal title="Delete unit" onClose={ handleToggleModalDelete.bind(null, props, -1) } onAccept={ handleDeleteUnit.bind(null, props) }>
              Delete this unit ?
            </Modal>
          : null
      }
    </fieldset>
  );
};

function handleToggleModalForm(props, bool, indexEditedUnit = -1) {
  const editedUnit = bool && indexEditedUnit !== -1
    ? { ...props.units[indexEditedUnit] }
    : { active: true, number: generateUnitNumber(props.units) };
  props.api.property.setData({ showModalFormUnit: bool, indexEditedUnit, editedUnit });
}
function generateUnitNumber(units) {
  if (!units || units.length === 0) return 1;
  const numbers = units.map(u => parseInt(u.number));
  let i = 1;
  let number = null;
  while (!number) {
    if (!numbers.includes(i)) {
      number = i;
    } else {
      i++;
    }
  }
  return number;
}
function handleChangeUnit(props, attributeName, field) {
  const editedUnit = { ...props.editedUnit };
  if (attributeName === 'active') {
    editedUnit[attributeName] = !editedUnit[attributeName];
  } else {
    editedUnit[attributeName] = field.value;
  }
  props.api.property.setData({ editedUnit });
}
function handleSaveUnit(props) {
  const units = props.units.slice();
  const editedUnit = { ...props.editedUnit };
  if (props.indexEditedUnit === -1) {
    units.push(editedUnit);
  } else {
    units[props.indexEditedUnit] = editedUnit;
  }
  props.onChange(units);
  props.api.property.setData({ showModalFormUnit: false, indexEditedUnit: -1, editedUnit: null });
}

function handleToggleModalDelete(props, indexDeleteUnit = -1) {
  const showModalDeleteUnit = indexDeleteUnit !== -1;
  props.api.property.setData({ showModalDeleteUnit, indexDeleteUnit });
}
function handleDeleteUnit(props) {
  const units = props.units.slice();
  units.splice(props.indexDeleteUnit, 1);
  props.onChange(units);
  props.api.property.setData({ showModalDeleteUnit: false, indexDeleteUnit: -1 });
}

UnitsFieldset.propTypes = {
  api: React.PropTypes.object,
  units: React.PropTypes.array,
  showIcal: React.PropTypes.bool,
  showRemoteId: React.PropTypes.bool,
  onChange: React.PropTypes.func,
};

export default api.connect(UnitsFieldset, 'property', { noClearOnUnmount: true });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/UnitsFieldset.jsx